import React from 'react';
import TagSelector, { TagSelectorProps } from '@/components/selectors/TagSelector';
import { ValidationRule } from '@core/utils/validation.ts';
import { useFormField } from '@core/hooks/useFormField';

export interface FormTagSelectProps extends Omit<TagSelectorProps, 'error' | 'helperText' | 'onBlur'> {
    name: string;
    rules?: ValidationRule[];
    helperText?: string;
}

export const FormTagSelect: React.FC<FormTagSelectProps> = ({
    name,
    rules = [],
    value,
    onChange,
    helperText: staticHelperText,
    ...selectorProps
}) => {
    const { error, showError, handleBlur, handleChange } = useFormField({
        name,
        label: selectorProps.label,
        value,
        rules,
        onChange
    });

    return (
        <TagSelector
            {...selectorProps}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showError}
            helperText={showError ? error : staticHelperText}
            data-form-field={name}
        />
    );
};

FormTagSelect.displayName = 'FormTagSelect';

export default FormTagSelect;
